













































import Vue from 'vue';

export default Vue.extend({
  name: 'Button',
  props: {
    link: {
      type: String,
      required: false,
      default: null,
    },
    sticky: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    secondary: {
      type: Boolean,
      required: false,
      default: false,
    },
    external: {
      type: Boolean,
      required: false,
      default: false,
    },
    event: {
      type: String,
      required: false,
      default: 'External Link',
    },
    destination: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      disabledClass: 'bg-red-200 text-gray-600 ',
      primaryClass: 'bg-red-600 hover:bg-red-800 focus:bg-red-600 text-white ',
      secondaryClass:
        'bg-white hover:bg-red-200 focus:bg-white text-black border-red-800 border ',
    };
  },
  computed: {
    enabledClass(): string {
      return (this.secondary) ? this.secondaryClass : this.primaryClass;
    },
    baseClass(): string {
      return (this.disabled)
        ? this.disabledClass
        : this.enabledClass;
    },
    stickyClass(): string {
      let classes = this.baseClass;
      classes += 'sticky bottom-0 sm:relative rounded-none sm:rounded-lg';
      return classes;
    },
    standardClass(): string {
      let classes = this.baseClass;
      classes += 'rounded-lg shadow-md';
      return classes;
    },
  },
});
